import Vue from "vue";

export const PreventDialogEventBus = new Vue();
